'use strict';

var Bacon, R, currentPosition, currentPositionWithErrors, distance, distanceTo, error, getCurrentPosition, next, positionActive, positionEnabled, resUtil, watchCurrentPosition;

Bacon = require('baconjs');

R = require('ramda');

resUtil = require('../utils/resources');

next = function next(val) {
  return new Bacon.Next(val);
};

error = function error(err) {
  return new Bacon.Error(err.message);
};

getCurrentPosition = function getCurrentPosition() {
  return Bacon.fromBinder(function (sink) {
    var gotError, gotPosition;
    gotPosition = function gotPosition(position) {
      sink(next(position));
      return sink(new Bacon.End());
    };
    gotError = function gotError(err) {
      sink(error(err));
      return sink(new Bacon.End());
    };
    navigator.geolocation.getCurrentPosition(gotPosition, gotError, {
      enableHighAccuracy: true,
      timeout: 20000,
      maximumAge: 5 * 60 * 1000
    });
    return function () {}; // noop
  });
};

watchCurrentPosition = function watchCurrentPosition(sink) {
  var watchID;
  watchID = navigator.geolocation.watchPosition(R.pipe(next, sink), R.pipe(error, sink), {
    enableHighAccuracy: false,
    timeout: 20000,
    maximumAge: 5 * 60 * 1000
  });
  return function () {
    return navigator.geolocation.clearWatch(watchID);
  };
};

positionEnabled = new Bacon.Bus();

window.zuppPositionEnabled = positionEnabled;

positionActive = positionEnabled.toProperty(false);

currentPositionWithErrors = positionActive.filter(R.equals(true)).flatMap(function () {
  return Bacon.fromBinder(watchCurrentPosition).takeWhile(positionActive);
}).map(R.prop('coords')).toProperty();

currentPosition = currentPositionWithErrors.skipErrors();

distanceTo = R.curry(function (p1, p2) {
  return distance(p1.latitude, p1.longitude, p2.latitude, p2.longitude, 'M');
});

// https://www.geodatasource.com/developers/javascript
distance = function distance(lat1, lon1, lat2, lon2, unit) {
  var dist, radlat1, radlat2, radlon1, radlon2, radtheta, theta;
  radlat1 = Math.PI * lat1 / 180;
  radlat2 = Math.PI * lat2 / 180;
  radlon1 = Math.PI * lon1 / 180;
  radlon2 = Math.PI * lon2 / 180;
  theta = lon1 - lon2;
  radtheta = Math.PI * theta / 180;
  dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = dist * 180 / Math.PI;
  dist = dist * 60 * 1.1515;
  if (unit === "K") {
    dist = dist * 1.609344;
  }
  if (unit === "M") {
    dist = dist * 0.8684;
  }
  return dist;
};

module.exports = {
  currentPositionWithErrors: currentPositionWithErrors,
  currentPosition: currentPosition,
  distance: distanceTo,
  enablePosition: function enablePosition() {
    return positionEnabled.push(true);
  }
};